import { useTranslation } from 'react-i18next'
import { Box, Typography, Paper, Button } from '@mui/material'
import { ReactComponent as Sheets } from '@/assets/img/sheets.svg'

type Props = {
  title?: string
  instruction?: string
  subInstruction?: string
  bgColor?: string
  buttonText?: string
  onClickFunction?: any
  caption?: boolean
}

const NoContentAvailable = ({
  title,
  instruction,
  subInstruction,
  bgColor,
  buttonText,
  onClickFunction,
  caption,
}: Props) => {
  const { t } = useTranslation()
  return (
    <Box
      component={bgColor ? Paper : Box}
      className={bgColor || ''}
      display="flex"
      minHeight="inherit"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      width="100%"
      p={2}
    >
      <Sheets />
      <Box mt={caption ? 2 : 0}>
        <Typography variant="h5" className="fontWeight-700">
          {title || t('noResultsFound')}
        </Typography>
      </Box>
      {instruction && (
        <Box maxWidth={400} margin="auto">
          <Typography variant={caption ? 'caption' : 'subtitle1'}>
            {instruction}
          </Typography>
        </Box>
      )}
      {subInstruction && (
        <Box maxWidth={400} margin="auto">
          <Typography variant={caption ? 'caption' : 'subtitle1'}>
            {subInstruction}
          </Typography>
        </Box>
      )}
      {buttonText && onClickFunction && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Button onClick={onClickFunction} variant="outlined" color="primary">
            {buttonText}
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default NoContentAvailable
